import React, { useEffect, useState } from 'react';
import VerificationPopup from './modals/VerificationPopup';
import styles from '../styles/newFeature.module.css';
import content from '../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from './qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from './Industry/FAQ_mobile';
import FrequentQuestions from './homePage/FrequentQuestions';
import MobilePDBanner from './common/MobilePDBanner';
import PersonalisedDemoBanner from './common/PersonalisedDemoBanner';
import TestimonialSection from './common/TestimonialSection';
import MobileTestimonialSection from './common/MobileTestimonialSection';
import ThreeStepForm from './common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from './common/OutletFeatures';
import { useRouter } from 'next/router';

const ElectricalPOS = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/electricalPOS/fast-and-secure-transactions.webp",
            tag: "Point of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Fast & Secure Transactions",
            desc: "QueueBuster POS ensures high sales efficiency for your electronics store with quick and secure transactions. We have designed the system to manage high-volume sales while never compromising on speed and security. In this way, transactions are made securely and instantly.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    <b>Multitasking with several payment modes:</b> cash, UPI, credit card, debit, and digital wallets.
                </>,
                <>
                    High Tech security features are to protect sensitive customer and business data.
                </>,
                <>
                    Decrease checkout times with an interface that is intuitive and with little margin for errors, and maximizes efficiency endeavors.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/electricalPOS/single-multistore.webp",
            tag: "Multiple Stores",
            icon: "/assets/groceries/fmcg/multistore.svg",
            title: "Single & MultiStore Management",
            desc: "Whether you have a single outlet or hundreds, QueueBuster POS will equip you with all the tools needed to help you manage your business with appreciated ease. Our software solution offers centralized control over how easy it is to monitor and manage every store from a single platform.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Track sales, stock, and employee performance amongst all the stores in real time.
                </>,
                <>
                    Implement consistent pricing, promotions, and policies across all your stores.
                </>,
                <>
                    Transfer stock easily between stores to fulfill customer demand and optimize inventory.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/electricalPOS/cloud-onpremise.webp",
            tag: "Cloud POS",
            icon: "/assets/electricalPOS/cloudpos.svg",
            title: "Cloud & OnPremise Flexibility",
            desc: "QueueBuster POS makes it flexible enough to map and manage all business data from anywhere with an easy-to-use cloud dashboard. It is an ideal solution for multi store monitoring and on-the-go decision making of the business.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk  to an expert",
            points: [
                <>
                    Access your store's data anytime, anywhere with our cloud-based solution.
                </>,
                <>
                    Well, the best fit is with businesses that have specific security requirements.
                </>,
                <>
                    As your business grows and evolves, this seamless switching between the cloud and on-premise will support those changes.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/electricalPOS/easy-ui.webp",
            tag: "Easy UI Interface",
            icon: "/assets/electricalPOS/easyui.svg",
            title: "Intuitive and Efficient Interface for Fast, Error-Free Operations",
            desc: "The QueueBuster POS interface is user-friendly and allows your staff to work with it right away, reducing training time and increasing the efficiency of operations. Its intuitive design enables your team to focus on delivering great customer service.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Easy navigation with screens laid out minimizes errors at the checkout stage.
                </>,
                <>
                    Personalized dashboards: Customize the interface based on the specific needs of your store.
                </>,
                <>
                    Easy Access to core features without much time wasted in ensuring that staff can help customers as quickly as needed.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/electricalPOS/integration.webp",
            tag: "Integration",
            icon: "/assets/electricalPOS/integration.svg",
            title: "Seamless Integration for Enhanced Efficiency",
            desc: "Integrate QueueBuster POS with any other tool or system that your electronics store uses. Our software provides you with scope for wide integration so that the ecosystem is very connected and helps drive much efficiency concerning business value.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Connect with any accountancy software to centralize finance management and reporting like GST Suvidha, Tally and Zoho.
                </>,
                <>
                    Integrate with e-commerce solutions to align online and in-store sales for a seamless integration with Shopify, Amazon, Flipkart etc.
                </>,
                <>
                    Integrate with contact management software for a better understanding of client relationships and marketing activities. 
                </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How is QueueBuster POS designed to handle high-volume transactions during peak hours?
                </span>
            ),
            des: "QueueBuster is designed to make sure that a high volume in transaction throughput is managed coherently, even through its peak hours. Our system is set up to have a seamless and fluent checkout design, whether there is a line of customers or not. The software is turbocharged with high-end processing algorithms meant for speed but without any compromise on security. It has an intuitive interface which reduces errors, and so your personnel can complete transactions in less time. In addition, QueueBuster POS accepts a variety of payment alternatives, which include cash, credit or debit cards, and even digital wallets; this sets consumers free to pay by their favorite means and without hassle. This all-in-one approach allows you to ensure a seamless customer experience, even during the busiest moments in the store.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Will QueueBuster POS work across multiple stores, and how is the stock handled across multiple stores?
                </span>
            ),
            des: "Yes, QueueBuster POS is fully functional across multiple stores. It provides a single view, where one can attain real-time monitoring and act as a management hub for the sale, inventory holding, and staff performance across all stores. Easily transfer stock around stores to cover demands, so no store will ever be out of stock on any bestseller. This system provides consistent pricing and promotions across all outlets, therefore ensuring brand consistency. This multistore feature is most effective when growing a business to preserve that ability to expand without the loss of control over the operations.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are some advantages of using a cloud-based POS system vs. an on-premise solution?
                </span>
            ),
            des: <>
            <p>One of the biggest benefits of the cloud-based POS system is that it's more accessible. Through the cloud-based solution, QueueBuster POS, you may access your store data at any time and from any device through the Internet. Such a service is particularly useful for businesses with multiple stores and for business owners whose changing situations force them to make decisions on the run. Cloud systems are also easier to update and maintain since all updates to the software happen without user intervention.</p>
            <p>Hence some businesses may have explicit security needs, or even their locations may not support the best connectivity available in the world today. Finally, QueueBuster POS provides a choice between the cloud or on-premise so that you simply switch as you like according to your changing behavior.</p>
            </> ,
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Just how secure is QueueBuster POS against customers' and business data theft?
                </span>
            ),
            des: "At the very core of QueueBuster POS lies security. It's beefed up with state-of-the-art safety features that secure sensitive customer and business data through high-level encryption protocols, ensuring its safety at the point of usage and storage, as well as periodic security updates for averting potential vulnerabilities. What is more, multilevel access controls are present within the QueueBuster POS to bar access to sensitive information based on the role of the user. This ensures that all the important data is exclusively available to the designated staff, thereby eliminating the risk associated with an insider job in terms of a data breach. So with a QueueBuster POS, you can be rest assured that your data is safe and in compliance with industry standards.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS assist you in their inventory management for electronic spare parts?
                </span>
            ),
            des: "Inventory management for electronic spare parts is a complex task due to line items that are high in number and low in quantity. It makes this simple with real-time tracking of inventory quantities so that customers can easily see how much stock is available in their inventories. It warns you early when the spare parts are low so that you can order the parts in advance before it is too late. On the other hand, it is the responsibility of QueueBuster POS to handle the spare parts by taking care of their lifecycle and ensuring new stock is taken into account along with return stock. This will also integrate with your suppliers, allowing you further automation on the reordering function to always keep your stock at an optimal level for customer demand.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Will QueueBuster POS integrate into my current e-commerce platform?
                </span>
            ),
            des: "QueueBuster POS will integrate with a lot of e-commerce platforms. That's what will allow you to have both your online and your in-store sales in sync. This guarantees consistency in inventory, pricing, and even promotions over all channels. The two combined systems enable you to view your customers in one perspective and work on giving them a seamless shopping experience, be it in the store or online. Thanks to the integration, you can centralize data on customers, which can be easily traced against purchase history and preference to launch targeted marketing campaigns. QueueBuster POS is designed to be flexible with the integration options in connecting to the tools you are already using for extended business operations.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What about CRM? How does QueueBuster POS deal with it?
                </span>
            ),
            des: "CRM—Relationships are managed and grown with built-in CRM tools in QueueBuster POS. It keeps the critical customer profiling, such as purchase history, preferences, and contact information, to make marketing efforts effective by sending them personalized promotions or reminders for maintaining products. It also offers loyalty programs to reward loyal customers with benefits that serve the purpose of increasing brand loyalty among the customers. Big CRM features let you manage more interactions with customers in a more meaningful way, leading to satisfaction for repeated business.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of support and training is available once a user has registered with QueueBuster POS?
                </span>
            ),
            des: "QueueBuster POS provides support in all the ways you and your team can be trained regarding the operation of the system. Our support team is dedicated to serving you and is always available to render help at any time concerning any sort of technical problem or query either by phone, email, or chat. Furthermore, we have very informative user manuals further explained with accompanying training materials that help your team to understand the solution better. We further offer tailor-made training sessions meant for features most relevant to your business operations for companies with specified needs. This enables the fact that you will always be assured of harvesting the most from QueueBuster POS without interference with your business.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How QueueBuster POS manage returns and refunds of electronics products?
                </span>
            ),
            des: "Returns and refunds works can turn into a chaotic situation. It's all cool, though, with electronic products where a few return policies and requirements may have to be met. QueueBuster POS typically makes it quite easy to use a straightforward return and refund management process. You are enabled to effect returns swiftly and ensure that the inventory adjustment is done correctly. Also, you can establish a real refund system through this platform, regardless of how the last transaction was paid back, be it in either cash or card or through any digital wallet. Additionally, in QueueBuster POS, one could track the reason for returns and develop patterns for potential action over possible problems relating to some products or suppliers. This minimalistic approach ensures that your return process is effective and customer-friendly.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Will QueueBuster POS be efficient for growing businesses?
                </span>
            ),
            des: "Definitely. It means, therefore, that QueueBuster POS grows right along with you. If you start from a single store and then increase your number of stores gradually, this is one POS that can quite effortlessly scale up with your business. It comes with scalable pricing plans and can be used to add users, devices, and locations as your business grows bigger. The software is cloud-based, which means it is easy to scale; there is no hardware involved, and upgrading of instances can be easily done. As your business grows, so does QueueBuster POS remains equivalently scalable to your needs, maintaining continued seamless operation, further contributing to an excellent customer experience.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
           </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/electricalPOS/Electrical Store-mobile.webp')" }}>
                        <div>
                            <h1>
                                <span>POS Software for Electrical Store</span><span></span>
                                <span>&nbsp;Electricals Store  </span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Make the customer experience fly faster and operate swiftly with the essential and dynamic software  QueueBuster POS  designed only for electronics stores. Our POS offers robustly reliable and flexible solutions to meet all your business needs—irrespective of whether you are managing one store or more than one outlet.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4.3rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/electricalPOS/newHero-img.webp"
                            heading={<>POS Software for </>}
                            staticHeading={<>Electrical Store</>}
                            description={"Make the customer experience fly faster and operate swiftly with the essential and dynamic software  QueueBuster POS  designed only for electronics stores. Our POS offers robustly reliable and flexible solutions to meet all your business needs—irrespective of whether you are managing one store or more than one outlet."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "63%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Stunning Features of QB Electricals Store POS Software</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for QB Electric Store POS Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for QB Electric Store POS Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default ElectricalPOS